/* eslint-disable react/sort-comp */
/* eslint-disable react/no-multi-comp, no-nested-ternary */
import React from 'react';
import { Icon } from 'semantic-ui-react';
import { MenuButton, handleFocusStolen, addHandler, removeHandlers, log } from '#emyw/core-lib';
import './index.css';
const isDefined = variable => Boolean(variable || variable === 0);
const CloseIcon = props => /*#__PURE__*/React.createElement("span", props, /*#__PURE__*/React.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "0.75em",
  height: "0.75em",
  fill: "currentColor",
  viewBox: "0 0 282.66634 282.9526",
  version: "1.1"
}, /*#__PURE__*/React.createElement("g", {
  transform: "matrix(34.822404,0,0,34.822404,-572.70534,-457.47666)"
}, /*#__PURE__*/React.createElement("path", {
  /* eslint-disable-next-line max-len */
  d: "m 23.232422,13.314453 -2.726563,2.726563 -2.724609,-2.72461 c -0.245905,-0.253786 -0.621334,-0.22363 -0.837891,0.002 l -0.326171,0.326172 c -0.227635,0.227651 -0.227635,0.604381 0,0.832031 l 2.724609,2.726563 -2.724609,2.726563 c -0.227634,0.22765 -0.227634,0.60438 0,0.832031 l 0.330078,0.330078 c 0.22765,0.227633 0.60438,0.227633 0.832031,0 l 2.726562,-2.726563 2.726563,2.726563 c 0.227999,0.227971 0.606498,0.228483 0.833984,0 v -0.002 l 0.328125,-0.330078 c 0.226785,-0.227814 0.225344,-0.602777 -0.002,-0.830078 l -2.724609,-2.726563 2.724609,-2.726563 c 0.226765,-0.226768 0.227143,-0.602106 0.002,-0.830078 l -0.328125,-0.332031 c -0.227492,-0.228475 -0.605992,-0.227978 -0.833984,0 z"
}))));
const SlideMenuContext = React.createContext();
const SlideMenuConsumer = SlideMenuContext.Consumer;
const SlideMenuProvider = SlideMenuContext.Provider;
class Tabable extends React.Component {
  constructor(props) {
    super(props);
    // this.state = {};
    this.componentDidMount = () => {
      this.addEventHandlers();
    };
    this.componentWillUnmount = () => {
      removeHandlers(this.handlers);
      // this.resetFocus(this.menuItemRef);
      if (this.handleItemUnmount) this.handleItemUnmount(this.menuItemRef);
      // this.moveFocus('up');
    };
    this.addEventHandlers = () => {
      addHandler({
        listeners: [{
          event: 'onclick',
          callback: e => {
            e.target.focus();
          }
        }, {
          event: 'onblur',
          callback: handleFocusStolen
        }],
        getElement: () => (this.menuItemRef || {}).firstElementChild,
        componentHandlers: this.handlers
      });
    };
    this.handlers = [];
  }
  render() {
    const {
      className: classProp,
      children,
      onEnter,
      onReturn,
      onClick: onClickProp,
      disabled,
      centered,
      spaced,
      enterOnClick,
      ...rest
    } = this.props;
    const className = 'slideMenu-tabable'.concat(centered ? ' centeredMenuItem' : '').concat(spaced ? ' spacedMenuItem' : '');
    return /*#__PURE__*/React.createElement(SlideMenuConsumer, null, consumerProps => {
      /* Try destructuring consumerProps with a fallback, as sometimes there's a disconnect between provider and consumer */
      const {
        onChange,
        setFocusedItem,
        moveFocus,
        resetFocus,
        handleItemUnmount
      } = consumerProps || {};
      // this.onChange = onChange;
      // this.setFocusedItem = setFocusedItem;
      // this.moveFocus = moveFocus;
      // this.resetFocus = resetFocus;
      this.handleItemUnmount = handleItemUnmount;
      return /*#__PURE__*/React.createElement("div", Object.assign({
        ref: x => {
          this.menuItemRef = x;
        },
        className: classProp
      }, rest), /*#__PURE__*/React.createElement(MenuButton, {
        className: className,
        as: "div",
        fluid: true,
        disabled: Boolean(disabled),
        onClick: e => {
          // log.trace('clicked forward');
          if (onClickProp) onClickProp(e);
          if (enterOnClick) {
            if (onChange) onChange(e);
            if (onEnter) onEnter(e);
          }
        }
      }, /*#__PURE__*/React.createElement("div", null, children)));
    });
  }
}
Tabable.defaultProps = {
  disabled: false,
  // subItem: false,
  centered: false,
  spaced: false
  // slim: false,
  // enterOnClick: false,
  // onEnter: () => null,
  // onReturn: () => null,
};
class TabableWrapper extends React.Component {
  constructor() {
    super(...arguments);
    // state = {};
    this.componentWillUnmount = () => {
      if (this.handleItemUnmount) this.handleItemUnmount(this.menuItemRef);
    };
  }
  render() {
    const {
      className: classProp,
      children,
      onEnter,
      onReturn,
      onClick: onClickProp,
      disabled,
      enterOnClick,
      ...rest
    } = this.props;
    const className = 'slideMenu-tabable-wrapper'.concat(disabled ? ' disabled' : '').concat(classProp ? " ".concat(classProp) : '');
    return /*#__PURE__*/React.createElement(SlideMenuConsumer, null, consumerProps => {
      const {
        /* onChange, setFocusedItem, moveFocus, resetFocus, */handleItemUnmount
      } = consumerProps || {};
      // this.onChange = onChange;
      // this.setFocusedItem = setFocusedItem;
      // this.moveFocus = moveFocus;
      // this.resetFocus = resetFocus;
      this.handleItemUnmount = handleItemUnmount;
      return /*#__PURE__*/React.createElement("div", Object.assign({
        // ref={(x) => { this.menuItemRef = x; }}
        className: className
      }, rest), children);
    });
  }
}

// TabableWrapper.propTypes = {
//     /** Disables menu item */
//     disabled: PropTypes.bool,
//     /** Renders item as a menu subitem with smaller font */
//     subItem: PropTypes.bool,
//     /** Center align item contents */
//     centered: PropTypes.bool,
//     /** Space item contents */
//     spaced: PropTypes.bool,
//     /** Reduces top and bottom padding */
//     slim: PropTypes.bool,
//     /** Renders item as 'enterable' when clicked (For items with focusable children) */
//     enterOnClick: PropTypes.bool,
//     /** Callback when item is selected */
//     onEnter: PropTypes.func,
//     /** Callback when menu returns from item */
//     onReturn: PropTypes.func,
// };

// TabableWrapper.defaultProps = {
//     disabled: false,
//     subItem: false,
//     centered: false,
//     spaced: false,
//     slim: false,
//     enterOnClick: false,
//     onEnter: () => null,
//     onReturn: () => null,
// };

class MenuItem extends React.Component {
  constructor(props) {
    super(props);
    // this.state = { childActive: false, childSelected: false };
    this.componentDidMount = () => {
      this.addEventHandlers();
    };
    this.componentWillUnmount = () => {
      // const { childActive/* , childSelected */ } = this.state;
      if (this.childActive) {
        this.handleBackClick();
        this.onChange();
        this.props.onReturn();
      }
      removeHandlers(this.handlers);
      this.handleItemUnmount(this.menuItemRef);
    };
    this.addEventHandlers = () => {
      addHandler({
        listeners: [{
          event: 'onblur',
          callback: handleFocusStolen
        }],
        getElement: () => (this.menuItemRef || {}).firstElementChild,
        componentHandlers: this.handlers
      });
    };
    this.handleSubBackClick = () => {
      // log.trace('clicked backward');
      // this.setState({ childActive: false });
      this.childActive = false;
      this.SlideMenuContentContainerRef.style.left = '';
      this.SlideMenuContentContainerRef.style.visibility = '';
      if ((this.initialFocus || {}).current !== false) this.menuItemRef.firstElementChild.focus();
      this.setFocusedItem(this.menuItemRef.firstElementChild, this.handlePrevBackClick);
      this.handleBackClick();
      this.onChange();
      this.props.onReturn();
    };
    this.setDefaultFocus = () => {
      const submenu = this.menuItemRef.lastChild.firstChild;
      let defaultItem;
      const containers = submenu.querySelectorAll(':scope>.slideMenu-tabable-wrapper:not(.disabled)');
      for (let i = 0; i < containers.length; i += 1) {
        /** Query for first tabable item, and make sure it's not disabled. Cannot just query non-disabled
         * items because then it might find a non-disabled child of a disabled element */
        const item = containers[i].querySelector('.slideMenu-tabable');
        if (item && !item.classList.contains('disabled')) {
          defaultItem = item;
          break;
        }
      }
      if (!defaultItem) {
        /* Give focus to menu back button */
        // log.trace('Defaulting focus to back button:', submenu.firstChild);
        defaultItem = submenu.firstChild;
      }
      if (defaultItem) {
        // log.trace('setting focus to', defaultItem, 'this.initialFocus:', this.initialFocus);
        if ((this.initialFocus || {}).current !== false) defaultItem.focus();
        this.setFocusedItem(defaultItem, this.handleSubBackClick);
      } else {
        log.warn('No menu items found!');
      }
    };
    this.handlers = [];
    this.childActive = false;
    this.childSelected = false;
  }
  // handleSwipeStart = (e) => {
  //     const event = ('changedTouches' in e) ? e.changedTouches[0] : e;
  //     this.touchStartCoords = { x: event.pageX, y: event.pageY };
  // }

  // handleSwipeMove = (e) => {
  //     log.trace('swipe heard');
  //     const event = ('changedTouches' in e) ? e.changedTouches[0] : e;
  //     this.touchEndCoords = { x: event.pageX - this.touchStartCoords.x, y: event.pageY - this.touchStartCoords.y };
  //     this.touchStartCoords = { x: event.pageX, y: event.pageY }; // Reset touch start coordinates
  //     if (Math.abs(this.touchEndCoords.x) > 0 /* && Math.abs(this.touchEndCoords.y) === 0 */) {
  //         e.preventDefault();
  //     } else {
  //         log.trace('touchEndCoords:', this.touchEndCoords);
  //     }
  // };

  render() {
    const {
      title,
      openTitle,
      className: classProp,
      children,
      onEnter,
      onReturn,
      disabled,
      onClick: onClickProp,
      onKeyDown,
      subItem,
      customIcon,
      customIconStyle,
      ...rest
    } = this.props;
    // const { childActive, childSelected } = this.state;
    const className = 'slideMenu-tabable-wrapper'.concat(disabled ? ' disabled' : '').concat(classProp ? " ".concat(classProp) : '');
    return /*#__PURE__*/React.createElement(SlideMenuConsumer, null, props => {
      this.handleBackClick = props.handleBackClick;
      this.handlePrevBackClick = props.handlePrevBackClick;
      this.onChange = props.onChange;
      this.setFocusedItem = props.setFocusedItem;
      this.moveFocus = props.moveFocus;
      this.resetFocus = props.resetFocus;
      this.initialFocus = props.initialFocus;
      this.handleItemUnmount = props.handleItemUnmount;
      this.functions = {
        onClick: () => {
          if (!this.SlideMenuContentRef) return;
          // this.setState({ childSelected: true });
          this.childSelected = true;
          // setTimeout(() => { this.SlideMenuContentContainerRef.scrollLeft = this.SlideMenuContentContainerRef.clientWidth; }, 0);
          this.SlideMenuContentRef.style.marginLeft = 'calc(-100% - 1px)';
        },
        handleBackClick: () => {
          if (!this.SlideMenuContentRef) return;
          // this.setState({ childSelected: false });
          // this.childSelected = false;
          // this.SlideMenuContentContainerRef.scrollLeft = 0;
          this.SlideMenuContentRef.style.marginLeft = '';
        },
        handlePrevBackClick: this.handleSubBackClick,
        setFocusedItem: props.setFocusedItem,
        moveFocus: props.moveFocus,
        resetFocus: props.resetFocus,
        handleItemUnmount: props.handleItemUnmount
      };
      return /*#__PURE__*/React.createElement("div", Object.assign({
        ref: x => {
          this.menuItemRef = x;
        },
        className: className
      }, rest), /*#__PURE__*/React.createElement(MenuButton, {
        className: 'enjoySlideMenuItemContainer slideMenu-tabable'.concat(subItem ? ' enjoySlideMenuSubItem' : ''),
        as: "div",
        fluid: true,
        disabled: Boolean(disabled),
        onClick: e => {
          // log.trace('clicked forward');
          if (onClickProp) onClickProp(e);
          props.onClick(e);
          props.onChange(e);
          onEnter(e);
          // this.setState({ childActive: true }, this.setDefaultFocus);
          this.childActive = true;
          this.SlideMenuContentContainerRef.style.left = '0';
          this.SlideMenuContentContainerRef.style.visibility = 'visible';
          this.setDefaultFocus();
        },
        onKeyDown: onKeyDown
      }, /*#__PURE__*/React.createElement("div", {
        className: "enjoySlideMenuItem"
      }, title, /*#__PURE__*/React.createElement(Icon, {
        name: customIcon || 'chevron right',
        style: customIconStyle
      }))), /*#__PURE__*/React.createElement("div", {
        ref: ref => {
          this.SlideMenuContentContainerRef = ref;
          if (!ref) return; // eslint-disable-line no-useless-return
          // this.SlideMenuContentContainerRef.ontouchstart = this.handleSwipeStart;
          // this.SlideMenuContentContainerRef.ontouchmove = this.handleSwipeMove;
          // this.SlideMenuContentContainerRef.ontouchend = this.handleSwipeMove;
        },
        className: 'enjoySlideMenuContentContainer' /* .concat(this.childActive ? ' active' : '') */ // eslint-disable-line max-len, react/jsx-curly-brace-presence
      }, /*#__PURE__*/React.createElement("div", {
        ref: ref => {
          this.SlideMenuContentRef = ref;
        },
        className: 'enjoySlideMenuContent' /* .concat(this.childSelected ? ' selected' : '') */ // eslint-disable-line max-len, react/jsx-curly-brace-presence
      }, /*#__PURE__*/React.createElement(MenuButton, {
        className: "enjoySlideMenuContentTitle slideMenu-tabable",
        as: "div",
        fluid: true,
        onClick: this.handleSubBackClick
      }, /*#__PURE__*/React.createElement(Icon, {
        name: "chevron left"
      }), openTitle || title), /*#__PURE__*/React.createElement(SlideMenuProvider, {
        value: {
          ...this.functions,
          initialFocus: props.initialFocus,
          onChange: props.onChange
        }
      }, children))));
    });
  }
}
MenuItem.defaultProps = {
  openTitle: null,
  disabled: false,
  subItem: false,
  onEnter: () => null,
  onReturn: () => null,
  customIcon: null,
  customIconStyle: null
};
class SelectableItem extends React.Component {
  constructor(props) {
    super(props);
    // this.state = {};
    this.componentDidMount = () => {
      this.addEventHandlers();
    };
    this.componentWillUnmount = () => {
      removeHandlers(this.handlers);
      this.handleItemUnmount(this.menuItemRef);
    };
    this.addEventHandlers = () => {
      const {
        onKeyDown,
        onKeyUp,
        onKeyPress
      } = this.props;
      addHandler({
        listeners: [{
          event: 'onclick',
          callback: e => {
            e.target.focus();
          }
        }, {
          event: 'onblur',
          callback: handleFocusStolen
        }, ...(onKeyDown ? [{
          event: 'onkeydown',
          callback: onKeyDown
        }] : []), ...(onKeyUp ? [{
          event: 'onkeyup',
          callback: onKeyUp
        }] : []), ...(onKeyPress ? [{
          event: 'onkeypress',
          callback: onKeyPress
        }] : [])],
        getElement: () => (this.menuItemRef || {}).firstElementChild,
        componentHandlers: this.handlers
      });
    };
    this.handlers = [];
  }
  render() {
    const {
      className: classProp,
      children,
      onEnter,
      /* onReturn, */onClick: onClickProp,
      onKeyDown,
      onKeyUp,
      onKeyPress,
      disabled,
      subItem,
      centered,
      spaced,
      slim,
      forwardedRef,
      enterOnClick,
      /* debug, */...rest
    } = this.props;
    // if (debug) log.trace('props:', this.props);
    const wrapperClassName = 'slideMenu-tabable-wrapper'.concat(disabled ? ' disabled' : '').concat(classProp ? " ".concat(classProp) : '');
    const className = 'enjoySlideMenuItemContainer slideMenu-tabable'.concat(subItem ? ' enjoySlideMenuSubItem' : '').concat(centered ? ' centeredMenuItem' : '').concat(spaced ? ' spacedMenuItem' : '').concat(slim ? ' slimMenuItem' : '');
    return /*#__PURE__*/React.createElement(SlideMenuConsumer, null, _ref => {
      let {
        onChange,
        setFocusedItem,
        moveFocus,
        resetFocus,
        handleItemUnmount
      } = _ref;
      this.onChange = onChange;
      this.setFocusedItem = setFocusedItem;
      this.moveFocus = moveFocus;
      this.resetFocus = resetFocus;
      this.handleItemUnmount = handleItemUnmount;
      return /*#__PURE__*/React.createElement("div", Object.assign({
        ref: ref => {
          if (ref) this.menuItemRef = ref;
          forwardedRef(ref);
        },
        className: wrapperClassName
      }, rest), /*#__PURE__*/React.createElement(MenuButton, {
        className: className,
        as: "div",
        fluid: true,
        disabled: Boolean(disabled),
        onClick: e => {
          // log.trace('clicked forward');
          if (onClickProp) onClickProp(e);
          if (enterOnClick) {
            onChange(e);
            onEnter(e);
          }
        }
        // onKeyDown={onKeyDown}
        // onKeyUp={onKeyUp}
        // debug={debug}
      }, /*#__PURE__*/React.createElement("div", null, children)));
    });
  }
}
SelectableItem.defaultProps = {
  disabled: false,
  subItem: false,
  centered: false,
  spaced: false,
  slim: false,
  forwardedRef: () => null,
  enterOnClick: false,
  onEnter: () => null
  // onReturn: () => null,
};
export default class SlideMenu extends React.Component {
  constructor() {
    super();
    // this.state = {
    //     selected: false,
    // };
    this.back = () => {
      let canNavigateBack = false;
      try {
        if (this.handleBack) {
          this.handleBack();
          canNavigateBack = true;
        }
      } catch {
        log.warn('Error calling this.handleBack');
      }
      this.closeButtonFocused = false;
      return canNavigateBack;
    };
    this.getClosestSibling = (element, direction) => {
      if (!element) return null;
      let sibling;
      if (direction === 'down') {
        sibling = element.nextSibling;
      } else if (direction === 'up') {
        sibling = element.previousSibling;
      }
      if (!sibling) return null;
      if (sibling.classList && sibling.classList.contains('slideMenu-tabable') && !sibling.classList.contains('disabled')) {
        /* Sibling is itself a tabable element */
        return sibling;
      }
      if (sibling.classList && sibling.classList.contains('slideMenu-tabable-wrapper') && !sibling.classList.contains('disabled')) {
        /* Sibling is a wrapper for a tabable item - return tabable child element */
        const siblingElement = sibling.querySelector('.slideMenu-tabable');
        if (siblingElement) return siblingElement;
      }
      /* Current sibling isn't a selectable item, try next sibling */
      return this.getClosestSibling(sibling, direction);
    };
    this.getTabableWrapper = element => {
      const container = (element || {}).parentElement;
      if (!container) return null;
      if (container.classList && container.classList.contains('slideMenu-tabable-wrapper')) {
        return container;
      }
      return this.getTabableWrapper(container);
    };
    this.handleItemUnmount = element => {
      if (!element) return;
      this.unmountedItems.push(element);
      if (this.focusedMenuItem === element || element.contains(this.focusedMenuItem)) {
        this.moveFocus('up');
      }
    };
    this.moveFocus = direction => {
      // log.trace('moving', direction);
      let container;
      if (!this.focusedMenuItem) {
        log.trace('focusedMenuItem not defined. resetting focus');
        this.resetFocus();
        return;
      }
      if (this.focusedMenuItem.classList && this.focusedMenuItem.classList.contains('enjoySlideMenuContentTitle')) {
        /* Element is the back button, so menu item containers are direct siblings, not siblings of parent */
        container = this.focusedMenuItem;
      } else {
        /* Element is a menu item, so other menu item containers are siblings of wrapper */
        container = this.getTabableWrapper(this.focusedMenuItem);
        // container = this.focusedMenuItem.parentElement;
      }
      if (!container) {
        log.warn('No tabable wrapper found!');
        this.resetFocus();
      }
      let closestItem;
      if (!this.closeButtonFocused) {
        closestItem = this.getClosestSibling(container, direction);
      } else if (direction === 'up') {
        /** Set this.closeButtonFocused equal to false but don't get closestItem. This will return
         * focus to this.focusedMenuItem, which is the previously focused item */
        this.closeButtonFocused = false;
      }
      if (closestItem) {
        this.focusedMenuItem = closestItem;
      } else if (direction === 'down' && this.closeButton) {
        /* No sibling down, so give focus to the close button */
        this.closeButtonFocused = true;
      }
      // log.trace('this.closeButtonFocused:', this.closeButtonFocused);
      if (this.closeButtonFocused) {
        this.closeButton.focus();
      } else if (this.focusedMenuItem) {
        this.focusedMenuItem.focus();
      } else {
        this.resetFocus();
      }
    };
    this.setInitialFocus = initialFocus => {
      if (this.initialFocus.current === initialFocus) return;
      this.initialFocus.current = initialFocus;
      if (initialFocus) this.resetFocus();else document.activeElement.blur();
    };
    this.resetFocus = unmountedItem => {
      // log.trace('resetting focus...');
      if (unmountedItem) this.unmountedItems.push(unmountedItem);
      if (!this.SlideMenuMainRef) {
        log.warn('No menu container reference!');
        return;
      }
      const items = Array.from(this.SlideMenuMainRef.firstChild.querySelectorAll(':scope>.slideMenu-tabable:not(.disabled), :scope>.slideMenu-tabable-wrapper:not(.disabled)'));
      if (!items.length) log.warn('No new focusable items found');
      /* Add currently focused item to beginning of list to check if focus can stay there */
      if (this.focusedMenuItem) items.unshift(this.focusedMenuItem);
      for (let i = 0; i < items.length; i += 1) {
        const item = items[i].classList.contains('slideMenu-tabable') ? items[i]
        /** If item is a wrapper, query for first tabable item, and make sure it's not disabled. Cannot just
         * query non-disabled items because then it might find a non-disabled child of a disabled element: */ : items[i].querySelector('.slideMenu-tabable');
        if (item && !item.classList.contains('disabled')) {
          let validItem = true;
          /* Verify element has not been unmounted */
          for (let j = 0; j < this.unmountedItems.length; j += 1) {
            const umItem = this.unmountedItems[j];
            if (item === umItem || umItem.contains(item)) {
              validItem = false;
              break;
            }
          }
          if (validItem) {
            this.focusedMenuItem = item;
            break;
          }
        }
      }
      // log.trace('this.closeButtonFocused:', this.closeButtonFocused);
      if (this.closeButtonFocused) {
        this.closeButton.focus();
      } else if (this.focusedMenuItem) {
        // log.trace('new focusedMenuItem:', this.focusedMenuItem);
        this.focusedMenuItem.focus();
      } else {
        log.warn('No focusable item found!');
      }
    };
    this.setFocusedItem = (menuElement, handleBack) => {
      this.focusedMenuItem = menuElement;
      this.closeButtonFocused = false;
      /* if (handleBack) */
      this.handleBack = handleBack; // Set this.handleBack or clear if handleBack param is undefined
      if (this.SlideMenuMainRef) this.SlideMenuMainRef.scrollLeft = 0;
    };
    /* Define functions after resetFocus so we can reference it directly; */
    /* eslint-disable-next-line react/sort-comp */
    this.functions = {
      onClick: () => {
        if (!this.SlideMenuItemsRef) return;
        // this.setState({ selected: true });
        this.selected = true;
        // setTimeout(() => { this.SlideMenuMainRef.scrollLeft = this.SlideMenuMainRef.clientWidth; }, 0);
        this.SlideMenuItemsRef.style.marginLeft = 'calc(-100% - 1px)';
      },
      handleBackClick: () => {
        if (!this.SlideMenuItemsRef) return;
        // this.setState({ selected: false });
        // this.selected = false;
        // this.SlideMenuMainRef.scrollLeft = 0;
        this.SlideMenuItemsRef.style.marginLeft = '';
      },
      setFocusedItem: this.setFocusedItem,
      moveFocus: this.moveFocus,
      resetFocus: this.resetFocus,
      handleItemUnmount: this.handleItemUnmount
    };
    this.selected = false;
    this.unmountedItems = [];
    this.SlideMenuMainRef = null;
    this.focusedMenuItem = null;
    this.closeButton = null;
    this.closeButtonFocused = false;
    this.initialFocus = {
      current: undefined
    };
    this.initialFocusProp = undefined;
  }
  componentDidMount() {
    if (this.initialFocus.current) this.resetFocus();
  }
  // handleWheelScroll = (e) => {
  //     /* If shiftKey is pressed, then scroll is horizontal, so prevent default */
  //     if (e.shiftKey) e.preventDefault();
  // };

  // handleSwipeStart = (e) => {
  //     const event = ('changedTouches' in e) ? e.changedTouches[0] : e;
  //     this.touchStartCoords = { x: event.pageX, y: event.pageY };
  // }

  // handleSwipeMove = (e) => {
  //     log.trace('swipe heard');
  //     const event = ('changedTouches' in e) ? e.changedTouches[0] : e;
  //     this.touchEndCoords = { x: event.pageX - this.touchStartCoords.x, y: event.pageY - this.touchStartCoords.y };
  //     this.touchStartCoords = { x: event.pageX, y: event.pageY }; // Reset touch start coordinates
  //     if (Math.abs(this.touchEndCoords.x) > 0 /* && Math.abs(this.touchEndCoords.y) === 0 */) {
  //         e.preventDefault();
  //     } else {
  //         log.trace('touchEndCoords:', this.touchEndCoords);
  //     }
  // };

  render() {
    // const { selected } = this.state;
    const {
      children,
      width,
      style,
      className: classProp,
      onChange,
      closeButton,
      onClose,
      initialFocus: initialFocusProp,
      ...rest
    } = this.props;
    if (!isDefined(style.width)) style.width = width;
    const className = 'enjoySlideMenu'.concat(classProp ? " ".concat(classProp) : '');
    // log.trace('base initialFocus:', initialFocus);
    if (this.initialFocusProp !== initialFocusProp) {
      /* Only update initialFocus if prop changes, since initialFocus can also be updated from setInitialFocus function */
      this.initialFocusProp = initialFocusProp;
      this.initialFocus.current = initialFocusProp;
    }
    return /*#__PURE__*/React.createElement("div", Object.assign({
      className: className,
      style: style
    }, rest), /*#__PURE__*/React.createElement("div", {
      className: "enjoySlideMenuContainer"
    }, /*#__PURE__*/React.createElement("div", {
      className: "enjoySlideMenuMain",
      ref: ref => {
        if (ref) this.SlideMenuMainRef = ref;
        if (!ref) return; // eslint-disable-line no-useless-return
        // this.SlideMenuMainRef.onwheel = this.handleWheelScroll;
        // this.SlideMenuMainRef.ontouchstart = this.handleSwipeStart;
        // this.SlideMenuMainRef.ontouchmove = this.handleSwipeMove;
        // this.SlideMenuMainRef.ontouchend = this.handleSwipeMove;
      }
    }, /*#__PURE__*/React.createElement("div", {
      ref: ref => {
        this.SlideMenuItemsRef = ref;
      },
      className: 'enjoySlideMenuItems' /* .concat(this.selected ? ' selected' : '') */ // eslint-disable-line max-len, react/jsx-curly-brace-presence
    }, /*#__PURE__*/React.createElement(SlideMenuProvider, {
      value: {
        ...this.functions,
        initialFocus: this.initialFocus,
        onChange
      }
    }, children))), closeButton ? /*#__PURE__*/React.createElement("div", {
      className: "enjoySlideMenuClose",
      ref: ref => {
        if (((ref || {}).firstChild || {}).firstChild) this.closeButton = ref.firstChild.firstChild;
      }
    }, /*#__PURE__*/React.createElement(SlideMenuProvider, {
      value: {
        ...this.functions,
        onChange
      }
    }, /*#__PURE__*/React.createElement(SelectableItem, {
      onClick: onClose
    }, typeof closeButton === 'boolean' || typeof closeButton === 'string' ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", null, typeof closeButton === 'string' ? closeButton : 'Close'), /*#__PURE__*/React.createElement(CloseIcon, {
      className: "enjoySlideMenuCloseIcon"
    })) : closeButton))) : null));
  }
}
SlideMenu.MenuItem = MenuItem;
SlideMenu.SelectableItem = SelectableItem;
SlideMenu.Tabable = Tabable;
SlideMenu.TabableWrapper = TabableWrapper;
SlideMenu.defaultProps = {
  width: '100%',
  style: {},
  className: '',
  onChange: () => null,
  initialFocus: true,
  closeButton: null,
  onClose: () => null
};